import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import SpeekComponent from "./speekComponent";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import useApi from "../../core/customhook/useApi";
import Loader from "../../core/common/selfLoder";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { apibaseurl } from "../../environment";

const WhoweAre = () => {
  const [empMessage, setEmpMessage] = useState<any>({});
  const [ceoMessage, setCeoMessage] = useState<any>({});
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const {
    data: ceomessage,
    error: ceomessageerror,
    loading: ceomessageloading,
  } = useApi("/api/ceo/message/view", {
    autoCall: true,
  });

  const {
    data: employeesmessage,
    error: employeesmessageerror,
    loading: employeesmessageloading,
  } = useApi("/api/employees/message/view", {
    autoCall: true,
  });

  function decodeHtml(html: string) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  return (
    <>
      {/* <Loader loading={loader} minDuration={1500} /> */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Who Are We </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Organization
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Who Are We
                  </li>
                </ol>
              </nav>
            </div>

            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          <div className="row">
            {/* Left column: Main content */}
            <div className="col-lg-8">
              {/* Section header card */}
              <div className="card mb-2">
                <div className="card-body p-3">
                  <h2 className="text-center">Who Are We</h2>
                </div>
              </div>

              {/* Content card with Swiper */}
              <div className="card mb-4">
                <div className="card-body">
                  {/* Swiper image carousel */}
                  <div className="mb-4">
                    <Swiper
                      modules={[Navigation, Pagination, Autoplay]}
                      spaceBetween={30}
                      navigation
                      pagination={{ clickable: true }}
                      loop={true}
                      autoplay={{ delay: 3000, disableOnInteraction: false }}
                      className="mb-4"
                    >
                       <SwiperSlide>
                        <img
                          src="assets/img/org/who-are-we-3.jpg"
                          alt={`Who Are We Slide`}
                          className="img-fluid rounded shadow-sm"
                          style={{ maxHeight: "400px", objectFit: "cover" }}
                        />
                      </SwiperSlide>
                          <SwiperSlide>
                        <img
                          src="assets/img/org/who-are-we-1.jpg"
                          alt={`Who Are We Slide`}
                          className="img-fluid rounded shadow-sm"
                          style={{ maxHeight: "400px", objectFit: "cover" }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src="assets/img/org/who-are-we-4 (1).jpg"
                          alt={`Who Are We Slide`}
                          className="img-fluid rounded shadow-sm"
                          style={{ maxHeight: "400px", objectFit: "cover" }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src="assets/img/org/who-are-we-2.jpg"
                          alt={`Who Are We Slide`}
                          className="img-fluid rounded shadow-sm"
                          style={{ maxHeight: "400px", objectFit: "cover" }}
                        />
                      </SwiperSlide>
                      {/* <SwiperSlide>
                        <img
                          src="assets/img/org/who-are-we-5.jpg"
                          alt={`Who Are We Slide`}
                          className="img-fluid rounded shadow-sm"
                          style={{ maxHeight: "400px", objectFit: "cover" }}
                        />
                      </SwiperSlide> */}
                    </Swiper>
                  </div>

                  {/* Text content */}
                  <div className="text-justify">
                    <p>
                      Since 2017, <strong>Team1 Consulting Pvt Ltd</strong> has
                      been building comprehensive IT strategies and solutions
                      for clients across the globe. We help you take care of
                      today and meet tomorrow head-on.
                    </p>
                    <p>
                      At Team1 Consulting, we focus on listening to you so that
                      we can align our services to your overall business
                      strategy. This alignment enables us to plan and manage
                      your technology landscape and provide services that help
                      increase business productivity and optimize costs.
                    </p>
                    <p>
                      We partner with you to adopt the right technologies that
                      support business growth. Our goal is to help your
                      organization become more agile and responsive to the
                      rapidly evolving digital landscape.
                    </p>
                    <p>
                      We are a team of technology enthusiasts who believe in
                      transforming possibilities into realities. By consistently
                      going beyond the ordinary, we deliver the best IT services
                      and solutions. We see ourselves as your trusted
                      partner—equipped to understand your challenges and deliver
                      best-in-class solutions.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Inline SpeekComponent Start */}
            <div className="col-md-4">
              <Loader loading={ceomessageloading || employeesmessageloading} />
              <div>
                <div className="theiaStickySidebar">
                  <div className="stickybar">
                    <div className="card custom-card">
                      <div className="card-body">
                        <Swiper
                          pagination={{
                            dynamicBullets: true,
                          }}
                          autoplay={{
                            delay: 5500,
                            disableOnInteraction: false,
                          }}
                          modules={[Pagination, Autoplay]}
                          className="pagination-dynamic"
                        >
                          <div className="swiper pagination-dynamic">
                            <div className="swiper-wrapper">
                              {ceomessage?.data?.map((item: any, index: any) => (
                                <SwiperSlide key={index} className="swiper-slide">
                                  <div className="card mb-3">
                                    <div className="card-body p-3">
                                      <div className="d-flex align-items-center justify-content-center mb-3">
                                        <h5 className="mb-0">CEO </h5>
                                      </div>

                                      <div className="d-flex justify-content-center flex-column gap-3">
                                        <div className="d-flex justify-content-center ">
                                          <div
                                            style={{
                                              border: "2px solid #ccc",
                                              borderRadius: "6px",
                                              padding: "4px",
                                              display: "inline-block",
                                              backgroundColor: "#fff",
                                              alignItems: "center",
                                            }}
                                          >
                                            <img
                                              src={item.photo || "/assets/img/logo/profilepic.jpg"}
                                              alt="Employee"
                                              style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "cover",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                        <div>
                                          <Link
                                            to="#"
                                            className="btn btn-primary custom_button px-4 py-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#ceomessage"
                                            onClick={() => setCeoMessage(item)}
                                            style={{ width: "100%" }}
                                          >
                                            Hear {item.employee_name}
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </SwiperSlide>
                              ))}
                            </div>
                            <div className="swiper-pagination" />
                          </div>
                        </Swiper>
                      </div>
                    </div>

                    {/* employeesmessage card */}
                    <div className="card custom-card speakComponent">
                      <div className="card-body">
                        <div className="custom-swiper-button-prev">
                          <img
                            ref={prevRef}
                            src="/assets/img/icon/arrow-left.png"
                            alt="Prev"
                            style={{ width: 14, height: 14 }}
                          />
                        </div>
                        <div className="custom-swiper-button-next">
                          <img
                            ref={nextRef}
                            src="/assets/img/icon/right-arrow.png"
                            alt="Next"
                            style={{ width: 14, height: 14 }}
                          />
                        </div>
                        {prevRef.current && nextRef.current && (
                          <Swiper
                            loop={true}
                            modules={[Pagination, Navigation]}
                            className="pagination-dynamic"
                            navigation={{
                              prevEl: prevRef.current,
                              nextEl: nextRef.current,
                            }}
                            onBeforeInit={(swiper: any) => {
                              swiper.params.navigation.prevEl = prevRef.current;
                              swiper.params.navigation.nextEl = nextRef.current;
                            }}
                          >
                            {employeesmessage?.data?.map((item: any, index: any) => (
                              <SwiperSlide key={index}>
                                <div className="card mb-3">
                                  <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-center mb-3">
                                      <h6 className="mb-0">Employee Voice</h6>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                      <img
                                        src={item.photo || "/assets/img/logo/profilepic.jpg"}
                                        alt="Employee"
                                        style={{
                                          width: "80px",
                                          height: "80px",
                                          objectFit: "cover",
                                          borderRadius: "6px",
                                          border: "2px solid #ccc",
                                          padding: "4px",
                                          backgroundColor: "#fff",
                                        }}
                                      />
                                    </div>
                                    <Link
                                      to="#"
                                      className="btn btn-primary custom_button mt-3 w-100"
                                      data-bs-toggle="modal"
                                      data-bs-target="#empmessage"
                                      onClick={() => setEmpMessage(item)}
                                    >
                                      {`Watch ${item.employee_name} Story`}
                                    </Link>
                                  </div>
                                </div>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        )}
                        {/* Custom arrows outside Swiper */}

                      </div>
                    </div>
                  </div>
                </div>

                {/* CEO message modal */}
                <div
                  className="modal fade"
                  id="ceomessage"
                  tabIndex={-1}
                  aria-labelledby="ceomessageLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title" id="ceomessageLabel">
                          CEO ({ceoMessage?.employee_name})
                        </h4>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        />
                      </div>

                      <div className="modal-body">
                        <video
                          key={apibaseurl + ceoMessage?.video_url}
                          width="100%"
                          controls
                          muted
                          autoPlay
                          playsInline
                          preload="auto"
                        >
                          <source
                            src={apibaseurl + ceoMessage?.video_url}
                            type="video/mp4"
                          />
                        </video>
                        <p className="mt-3 text-primary text-end">
                          <i>-- By {ceoMessage?.employee_name}</i>
                        </p>
                      </div>

                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Employee message modal */}
                <div
                  className="modal fade"
                  id="empmessage"
                  tabIndex={-1}
                  aria-labelledby="empmessageLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title" id="empmessageLabel">
                          {empMessage?.employee_name}
                        </h4>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        />
                      </div>
                      <div className="modal-body">
                        <i className="emp-message">
                          <strong
                            dangerouslySetInnerHTML={{
                              __html: decodeHtml(empMessage?.emp_message),
                            }}
                          />
                        </i>
                        <p className="mt-3 text-primary" style={{ textAlign: "right" }}>
                          <i>-- By {empMessage?.employee_name}</i>
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Inline SpeekComponent End */}
          </div>
        </div>

        <div className="footer d-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default WhoweAre;
